module.exports = __webpack_public_path__ + "img/max-file-check--zip.6433c099.svg";